<div class="flex flex-col gap-4">
  <!-- Approval filter (single-select) -->
  <div>
    <mat-button-toggle-group [value]="selectedApproval()" (change)="onApprovalChange($event.value)">
      <mat-button-toggle value="approved">
        {{ 'waters.media.approval.approved' | translate }} ({{ approvedCount() }})
      </mat-button-toggle>
      <mat-button-toggle value="not">
        {{ 'waters.media.approval.not' | translate }} ({{ notApprovedCount() }})
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Grid -->
  @if (filtered().length > 0) {
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      @for (item of filtered(); track item.id) {
        <div class="rounded-lg border border-gray-200 overflow-hidden flex flex-col bg-white">
          <!-- Thumbnail -->
          <div
            class="relative w-full aspect-square bg-gray-100 cursor-pointer overflow-hidden group"
            (click)="openLightbox(item)">
            @if (thumbUrl(item)) {
              <img
                [src]="thumbUrl(item)"
                [alt]="item.caption ?? ''"
                class="absolute inset-0 w-full h-full object-cover transition group-hover:brightness-95"
                [class.grayscale]="!item.approved"
                [class.opacity-40]="!item.approved" />
            }
            <!-- Not-approved overlay -->
            @if (!item.approved) {
              <span
                class="absolute inset-0 flex items-center justify-center text-gray-800 text-xl font-semibold text-center px-3">
                {{ 'waters.media.not-approved' | translate }}
              </span>
            }
            <!-- Play icon for videos -->
            @if (isVideo(item)) {
              <span class="absolute inset-0 flex items-center justify-center pointer-events-none">
                <mat-icon class="play-overlay-icon drop-shadow">play_circle</mat-icon>
              </span>
            }
            <!-- Highlight star (toggle) -->
            <button
              type="button"
              class="absolute top-2 right-2 inline-flex items-center justify-center w-9 h-9 rounded-full bg-teal-700 shadow transition"
              [matTooltip]="(item.highlight ? 'waters.media.action.highlight-remove' : 'waters.media.action.highlight') | translate"
              [attr.aria-label]="(item.highlight ? 'waters.media.action.highlight-remove' : 'waters.media.action.highlight') | translate"
              (click)="$event.stopPropagation(); toggleHighlight(item)">
              <mat-icon
                class="highlight-star transition-colors"
                [class.is-highlighted]="item.highlight">
                {{ item.highlight ? 'star' : 'star_border' }}
              </mat-icon>
            </button>
            <!-- Tag chip -->
            @if (item.tag) {
              <span
                class="absolute bottom-2 left-2 px-2.5 py-1 rounded-full bg-teal-700 text-white text-xs font-medium shadow">
                {{ 'waters.media.tag.' + item.tag | translate }}
              </span>
            }
          </div>

          <!-- Footer: description + actions -->
          <div class="p-3 flex flex-col gap-2">
            <p
              class="min-h-[2.5rem] text-sm line-clamp-2"
              [class.text-gray-400]="!item.caption"
              [class.italic]="!item.caption"
              [matTooltip]="item.caption ?? ''"
              [matTooltipDisabled]="!item.caption">
              {{ item.caption || ('waters.media.no-description' | translate) }}
            </p>
            <div class="flex items-center gap-1">
              <button
                mat-icon-button
                (click)="edit(item)"
                [matTooltip]="'waters.media.action.edit' | translate"
                [attr.aria-label]="'waters.media.action.edit' | translate">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                (click)="delete(item)"
                [matTooltip]="'waters.media.action.delete' | translate"
                [attr.aria-label]="'waters.media.action.delete' | translate">
                <mat-icon>delete</mat-icon>
              </button>
              <span class="flex-1"></span>
              @if (item.approved) {
                <button mat-stroked-button (click)="disapprove(item)">
                  {{ 'waters.media.action.disapprove' | translate }}
                </button>
              } @else {
                <button mat-flat-button color="primary" (click)="approve(item)">
                  {{ 'waters.media.action.approve' | translate }}
                </button>
              }
            </div>
          </div>
        </div>
      }
    </div>
  } @else if (!isLoading()) {
    <div class="text-center p-10">
      <mat-icon class="empty-state-icon mb-4">photo_library</mat-icon>
      <p class="text-gray-700 text-base">{{ 'waters.media.empty-filtered' | translate }}</p>
    </div>
  }
</div>
